import { InputGroup, SexSelect, TextArea } from "#common";
import FosterDropdown from "./foster_dropdown";
function PrimaryInformation({ animal, onChange }) {
  return !animal ? (
    <div />
  ) : (
    <div className="flex flex-col gap-4 pt-2">
      <FosterDropdown animal={animal} onChange={onChange} />
      <InputGroup
        label="Name"
        name="name"
        value={animal.name}
        onChange={onChange}
      />
      <SexSelect value={animal.sex} name="sex" onChange={onChange} />
      <InputGroup
        type="date"
        label="Birth Date"
        name="birthDate"
        value={animal.birthDate}
        onChange={onChange}
      />
      <div className="flex item-center gap-2">
        <InputGroup
          label="Color"
          name="color"
          value={animal.color}
          onChange={onChange}
        />
        <InputGroup
          label="Coat"
          name="coat"
          value={animal.coat}
          onChange={onChange}
        />
      </div>
      <TextArea
        label="Notes"
        value={animal.notes}
        name="notes"
        onChange={onChange}
        ropw={4}
      />
    </div>
  );
}
export default PrimaryInformation;
